import React, { useEffect, useState } from "react";
import axios from "axios";
import { Mascot } from "./Mascot";
import { CautionMarquee } from "./CautionMarquee";
import { RandomButton } from "./RandomButton";
import { ArrowDown, Flame, Siren } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const Hero = ({ onJump }) => {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    axios.get(`${API}/stats`).then((r) => setStats(r.data)).catch((e) => console.error(e));
  }, []);

  const tiles = [
    { k: "INCIDENTS", v: stats ? String(stats.incidents) : "…", id: "incidents" },
    { k: "SUPERCARS LOST", v: stats ? `≥ ${stats.supercars_lost}` : "…", id: "supercars" },
    { k: "CRINGE Σ", v: stats ? `${stats.cringe_sum}/${stats.cringe_max}` : "…", id: "cringe" },
    { k: "REACTIONS", v: stats ? stats.reactions_total.toLocaleString() : "…", id: "reactions" },
  ];

  return (
    <section className="relative pt-10 pb-20 overflow-hidden" data-testid="hero">
      {/* Giant background type */}
      <div
        className="pointer-events-none select-none absolute inset-0 flex items-center justify-center"
        aria-hidden
      >
        <span
          className="heading text-[22vw] md:text-[16vw] text-white/[0.03] whitespace-nowrap"
          style={{ WebkitTextStroke: "2px rgba(255,255,255,0.06)" }}
        >
          DOHERTY
        </span>
      </div>

      <div className="relative max-w-7xl mx-auto px-5 md:px-10">
        {/* top strip */}
        <div className="flex items-center gap-3 mb-8 flex-wrap">
          <span className="inline-flex items-center gap-2 bg-[#FF003C] text-white font-mono text-xs px-3 py-1 brutal-border" style={{borderWidth: 3}}>
            <Siren size={14} strokeWidth={3} />
            UNAUTHORIZED ARCHIVE
          </span>
          <span className="font-mono text-xs text-white/60 uppercase">
            Est. 2017 — Updated: Today, Probably
          </span>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-end">
          <div className="lg:col-span-8 space-y-6">
            <h1 className="heading text-[clamp(3rem,10vw,8rem)] text-white leading-[0.85]">
              THE JACK <br />
              <span className="inline-block bg-[#FFEA00] text-black px-3 py-1 -skew-y-1">
                DOHERTY
              </span>
              <br />
              HALL OF <span className="text-[#FF003C]">SHAME</span>
            </h1>
            <p className="max-w-2xl text-base md:text-lg text-white/80 leading-relaxed">
              Every dumb thing Kick&rsquo;s loudest trust-fund&nbsp;adjacent streamer
              has ever done, catalogued, ranked and rated. Scroll down.
              Judge responsibly. (You won&rsquo;t.)
            </p>

            <div className="flex flex-wrap items-center gap-3">
              <button
                onClick={() => onJump && onJump("timeline")}
                data-testid="cta-timeline"
                className="brutal-press inline-flex items-center gap-2 bg-[#FFEA00] text-black font-bold uppercase px-5 py-3 brutal-border"
                style={{ boxShadow: "6px 6px 0 0 #FF003C" }}
              >
                <ArrowDown size={18} strokeWidth={3} />
                Open the Dossier
              </button>
              <button
                onClick={() => onJump && onJump("hall-of-shame")}
                data-testid="cta-hall"
                className="brutal-press inline-flex items-center gap-2 bg-[#FF003C] text-white font-bold uppercase px-5 py-3 brutal-border"
                style={{ boxShadow: "6px 6px 0 0 #FFEA00" }}
              >
                <Flame size={18} strokeWidth={3} />
                Hall of Shame
              </button>
              <RandomButton />
            </div>

            <dl className="pt-4 grid grid-cols-2 sm:grid-cols-4 gap-3 max-w-2xl" data-testid="hero-stats">
              {tiles.map((s) => (
                <div
                  key={s.k}
                  className="brutal-border bg-black p-3"
                  style={{ borderWidth: 3 }}
                >
                  <dt className="font-mono text-[10px] text-white/60 uppercase">
                    {s.k}
                  </dt>
                  <dd className="heading text-3xl text-[#FFEA00]" data-testid={`stat-${s.id}`}>{s.v}</dd>
                </div>
              ))}
            </dl>
          </div>

          <div className="lg:col-span-4 relative flex justify-center lg:justify-end">
            <div className="relative">
              {/* decorative stamps */}
              <div
                className="absolute -top-6 -left-10 rotate-[-14deg] font-mono text-xs px-3 py-1 bg-[#FF00FF] text-black brutal-border z-10"
                style={{ borderWidth: 3 }}
              >
                CERTIFIED CRASHOUT
              </div>
              <div
                className="absolute -bottom-4 -right-6 rotate-[8deg] font-mono text-[11px] px-3 py-1 bg-[#FFEA00] text-black brutal-border z-10"
                style={{ borderWidth: 3 }}
              >
                UNEMPLOYABLE
              </div>
              <Mascot size={280} shake />
            </div>
          </div>
        </div>
      </div>

      <div className="mt-14 -rotate-1 origin-left">
        <CautionMarquee background="#FFEA00" color="#000" speed={70} />
      </div>
      <div className="rotate-1 origin-right -mt-3">
        <CautionMarquee background="#000" color="#FFEA00" speed={55} reverse />
      </div>
    </section>
  );
};
